import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {IconComponent} from '@shared/icon';
import {UserFormSection} from '../../../models/user-form.types';
import {UserFormFactory} from '../../../services/user-form.factory';

@Component({
	selector: 'dc-user-form-section-validity-indicator',
	imports: [IconComponent],
	styles: ``,
	template: `
		<div class="flex items-center">
			<!-- תקין - אייקון צ'ק ירוק -->
			@if (sectionValidity().valid) {
				<icon icon="fas fa-check-circle" class="text-green-500 text-lg"></icon>
			}

			<!-- טרם נגע ויש ולידציות - אייקון נקודת שאלה צהובה -->
			@if (!sectionValidity().touched && !sectionValidity().valid) {
				<icon icon="fas fa-question-circle" class="text-yellow-500 text-lg"></icon>
			}

			<!-- שגוי - אייקון איקס אדום -->
			@if (sectionValidity().touched && !sectionValidity().valid) {
				<icon icon="fas fa-times-circle" class="text-red-500 text-lg"></icon>
			}
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionValidityIndicatorComponent {
	protected readonly userFormFactory = inject(UserFormFactory);

	public readonly section = input.required<UserFormSection>();

	protected readonly sectionValidity = computed(() => this.userFormFactory.formSectionValidity$()[this.section()]);
}
